import { wsNameV3 } from "@wingspanhq/utils/dist/name/wsNameV3";
import { Account, Address } from "@wingspanhq/wingspan-api-sdk";

export type AnalyticsAccountTraits = {
  userId?: string;
  organizationId?: string;
  displayName?: string;
  email?: string;
  phone?: string;
  companyName?: string;
  legalBusinessName?: string;
  website?: string;
  address?: {
    street: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };
};

const toTraitAddress = (address?: Address | null) => {
  if (
    !address?.line1 ||
    !address.city ||
    !address.state ||
    !address.postalCode ||
    !address.country
  ) {
    return undefined;
  }

  return {
    street: address.line2
      ? `${address.line1}, ${address.line2}`
      : address.line1,
    city: address.city,
    state: address.state,
    postalCode: address.postalCode,
    country: address.country
  };
};

export const selectorAnalyticsAccountTraits = (
  account: Account
): AnalyticsAccountTraits => {
  const company = account.profile?.company;
  const individual = account.profile?.individual;
  const complianceEntity = account.complianceEntity;

  return {
    userId: account.id ?? undefined,
    organizationId: account.organizationId ?? undefined,
    displayName: wsNameV3({ account }).resolvedName,
    email: complianceEntity?.email ?? undefined,
    phone:
      individual?.phoneNumber ?? complianceEntity?.phoneNumber ?? undefined,
    companyName: company?.doingBusinessAs || company?.legalBusinessName,
    legalBusinessName: company?.legalBusinessName,
    website:
      company?.website ||
      company?.links?.websiteUrl ||
      complianceEntity?.websiteUrl ||
      undefined,
    address: toTraitAddress(
      company?.address ?? individual?.address ?? complianceEntity?.address
    )
  };
};
